import React from 'react';
import { SectionHeader } from './SectionHeader';
import { ArticleCard } from './ArticleCard';
import { PlusButton } from './PlusButton';
import { MpuAdBox } from './MpuAdBox';
const MPU_IMAGE = 'https://cdn.magicpatterns.com/uploads/hiNQANwGZEdJgsmwXK7AZZ/mpu.jpg';
const articles = [{
  imageUrl: 'https://cdn.magicpatterns.com/uploads/mqV95i2atqsYCQuprwNWY1/Rectangle_234_(3).jpg',
  title: 'The Brands and Marketers Who Actually Won 2025',
  description: 'In 2025, marketing noise was everywhere. Visibility was easy to buy, reach was easy to inflate—but true distinction was rare.',
  category: 'NEWS'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/azzG98RXKpLoPhfPkkeSeA/Rectangle_235_(3).jpg',
  title: 'Top 70 CEOs Most Influential Leaders in Advertising, Media & Production',
  description: "Special Group, a global independent creative network, was the year's biggest climber in North America.",
  category: 'NEWS'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/6NGDo22TSgUgrKSkMpFoJF/Rectangle_236_(4).jpg',
  title: 'Mazda and Disney Are Big Winners at Oscars With Cinematic Ad Takeover',
  description: "Special Group, a global independent creative network, was the year's biggest climber in North America.",
  category: 'NEWS'
}];
export function RankingArticles() {
  return <section className="site-container" style={{
    marginTop: '60px',
    marginBottom: '60px'
  }} data-id="element-205">
      <div className="flex flex-col lg:flex-row gap-8 lg:gap-[37px] items-start" data-id="element-206">
        {/* LEFT: 3 Article Cards with Ranking badge */}
        <div className="flex-1 min-w-0 w-full" data-id="element-207">
          <SectionHeader label="Ranking" data-id="element-208" />
          <div className="relative -mt-4" data-id="element-209">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-[37px]" data-id="element-210">
              {articles.map((article, idx) => <ArticleCard key={idx} index={idx} imageUrl={article.imageUrl} title={article.title} description={article.description} category={article.category} data-id="element-211" />)}
            </div>
            {/* Plus icon on right edge */}
            <div className="absolute -right-3 lg:-right-5 top-[25%] hidden md:block" data-id="element-212">
              <PlusButton size="sm" data-id="element-213" />
            </div>
          </div>
        </div>

        {/* RIGHT: MPU Ad + Connect button */}
        <div className="flex-shrink-0 flex flex-col items-center self-start mx-auto lg:mx-0" data-id="element-214">
          {/* MPU Ad box */}
          <MpuAdBox src={MPU_IMAGE} className="mt-[17px]" data-id="element-215" />

          {/* Connect With Us button */}
          <button className="cursor-pointer transition-all duration-300 ease-in-out hover:opacity-80" style={{
          width: '285.75px',
          height: '57px',
          borderRadius: '18.75px',
          backgroundColor: '#090909',
          color: '#FFF',
          fontFamily: 'Poppins, sans-serif',
          fontSize: '14px',
          fontWeight: 700,
          letterSpacing: '1px',
          textTransform: 'uppercase' as const,
          marginTop: '24px',
          border: 'none'
        }} data-id="element-216">
            Connect With Us
          </button>
        </div>
      </div>
    </section>;
}